import appClient from '../../common/services/AppClient';
import { endpoints } from '../../../config';
import { ContractHistoryPageDto } from '../history/types';

export async function loadContractHistory(
    sessionId: string,
    page: number,
    ascending: boolean,
    throughSequence?: number
): Promise<ContractHistoryPageDto> {
    const query = new URLSearchParams({ page: String(page - 1), ascending: String(ascending) });
    if (throughSequence !== undefined) {
        query.set('throughSequence', String(throughSequence));
    }
    const result = await appClient.get<ContractHistoryPageDto>(
        `${endpoints.iotaUrl}contracts-ingestion/history/${encodeURIComponent(sessionId)}?${query}`
    );
    if (result.isErr()) {
        throw new Error('Could not load Contract history. Please try again.');
    }
    return result.value;
}
